export const extrasArrayFields = ["collections"];

export const APL_AUTHOR_FOLDER = {
  pioneerAuthors: 16,
  recentAuthors: 19,
};
export const APL_AUTHOR_FOLDERS = Object.values(APL_AUTHOR_FOLDER);
